module.exports = __webpack_public_path__ + "static/media/3Rectangle.b415d096.jpeg";